/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_DocumentInputs */



/**
* | output |
* | --- |
* | "Document" |
*
* @param {Chat_Activity_Kind_DocumentInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_document = /** @type {((inputs?: Chat_Activity_Kind_DocumentInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_DocumentInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Document")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Document")
	return /** @type {LocalizedString} */ ("Document")
});